export default "__VITE_ASSET__D5fC9C58__"